<template>
  <div class="enriched-autocomplete">
    <PflegeAutocomplete
      v-model="modelValue"
      :disabled="isLoading"
      :error-message="errorMessage"
      :has-error="hasError"
      :has-success="hasSuccess"
      :label="label"
      :options="listOfOptions"
      :placeholder="placeholder"
      :required="required"
      :return-object="true"
      @blur="$emit('blur', $event)"
      @update:model-value="$emit('input', $event)"
    >
      <template #hint>
        <slot name="hint"></slot>
      </template>
    </PflegeAutocomplete>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'

const modelValue = defineModel({ type: [Object, String] })
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    required: false,
    default: null
  },
  values: {
    type: Array,
    required: false,
    default: null
  },
  name: {
    type: String,
    required: false,
    default: null
  },
  type: {
    type: String,
    required: false,
    default: null
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  },
  hasSuccess: {
    type: Boolean,
    required: false,
    default: false
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false
  },
  errorMessage: {
    type: String,
    required: false,
    default: ''
  }
})
defineEmits(['input', 'blur'])

const isLoading = ref(false)
const listOfOptions = ref([])

const LIST_API_DOMAIN = inject('WIZCO_LIST_API_DOMAIN')

const getList = async (type) => {
  isLoading.value = true
  fetch(`${LIST_API_DOMAIN}/storyblok/get-list/${type}`)
    .then((response) => {
      if (!response.ok) {
        console.error(`server-error from list ${type}`, response)
        return
      }
      return response.json()
    })
    .then(({ list }) => {
      listOfOptions.value = list
    })
    .catch((e) => {
      console.error(`could not load list ${type}!!`, e)
    })
    .finally(() => {
      isLoading.value = false
    })
}

onMounted(() => {
  getList(props.type)
})
</script>
